if (!customElements.get('image-with-text-video')) {
  customElements.define('image-with-text-video', class ImageWithTextVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.muteBtn = this.querySelector('.image-with-text__mute-btn');
      this.playBtn = this.querySelector('.image-with-text__play-btn');
      this.poster = this.querySelector('.deferred-media__poster');
      this.observer = null;
    }

    connectedCallback() {
      if (!this.video) return;
      this.init();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    init() {
      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', (e) => this.toggleMute(e));
        this.updateMuteState();
      }

      if (this.playBtn) {
        this.playBtn.addEventListener('click', (e) => this.togglePlay(e));
      }

      this.video.addEventListener('play', () => this.onPlay());
      this.video.addEventListener('pause', () => this.onPause());
      this.video.addEventListener('volumechange', () => this.updateMuteState());

      if (this.video.hasAttribute('autoplay')) {
        this.video.removeAttribute('autoplay');
        this.setupAutoplayObserver();
      }
    }

    setupAutoplayObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.playVideo();
          } else {
            this.pauseVideo();
          }
        });
      }, { root: null, rootMargin: '0px', threshold: 0.4 });

      this.observer.observe(this);
    }

    playVideo() {
      if (this.video.paused) {
        this.video.play().catch(() => { });
      }
    }

    pauseVideo() {
      if (!this.video.paused) {
        this.video.pause();
      }
    }

    togglePlay(e) {
      e.preventDefault();
      if (this.video.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    }

    onPlay() {
      if (this.playBtn) {
        this.playBtn.classList.add('is-hidden');
      }
      this.classList.add('is-playing');
    }

    onPause() {
      if (this.playBtn) {
        this.playBtn.classList.remove('is-hidden');
      }
      this.classList.remove('is-playing');
    }

    toggleMute(e) {
      e.preventDefault();
      e.stopPropagation();
      this.video.muted = !this.video.muted;
    }

    updateMuteState() {
      if (!this.muteBtn) return;

      const isMuted = this.video.muted;
      this.muteBtn.classList.toggle('is-muted', isMuted);
      this.muteBtn.setAttribute('aria-label', isMuted ? 'Ativar som' : 'Desativar som');

      if (!isMuted) {
        this.muteBtn.style.animation = 'none';
      } else {
        this.muteBtn.style.animation = '';
      }
    }
  });
}
